/*global jQuery, subscribeToCalendars, console*/
(function ($)
{
    /// <summary>
    /// MultiCalendar Widget
    /// Defines a jQuery UI widget to manage multi calendar sections.
    /// </summary>
    $.widget("ui.MultiCalendar",
        {
            options:
            {
                UsingSelector: false,
                SubscribeUrl: null,
                GridUrl: null,
                /// <summary>
                /// Specifies how to display the calendar results. 
                /// Possible values: 'Grid' or 'List'
                /// </summary>
                DisplayType: 'Grid',
                /// <summary>
                /// Ajax link to the source of calendar events.
                /// </summary>
                AgendaUrl: null,
                /// <summary>
                /// Use Event Popups
                /// </summary>
                UseEventPopups: true,
                /// <summary>
                /// Bind iCalFeed Scubscribe button.
                /// </summary>
                BindSubscribeButton: true,
                /// <summary>
                /// Format Pattern for the selected text in the drop list.
                /// Default: '# of # selected'
                /// </summary>
                SelectedTextPattern: '# of # selected'
            },

            /// <summary>
            /// widget destroy.
            /// </summary>
            _destroy: function ()
            {
                return undefined;
            },

            /// <summary>
            /// widget ui initialization.
            /// </summary>
            _init: function ()
            {
                return undefined;
            },

            /// <summary>
            /// widget ui let's create this widget!
            /// </summary>
            _create: function ()
            {
                var self,
                    jElement,
                    multiSelectCallback,
                    jCalendarSelectBox,
                    wrapForEnterKey,
                    wrapForLink,
                    displayListCallback,
                    displayGridCallback;

                self = this;
                jElement = $(self.element);

                // Callback for multiselect changes.
                multiSelectCallback = function (/*event, ui*/) 
                {
                    self.Refresh();
                };

                if (self.options.UsingSelector)
                {
                    // Initialize multiselect widget for calendars.
                    jCalendarSelectBox = $(self.element).find("select[name='add_to_calendar_id']");

                    jCalendarSelectBox.multiselect(
                        {
                            selectedList: false,
                            noneSelectedText: "(Please select a calendar)",
                            close: function (event, ui)
                            {
                                multiSelectCallback(event, ui);
                                jCalendarSelectBox.parent().children('button.ui-multiselect').focus();
                            },
                            click: multiSelectCallback,
                            checkAll: multiSelectCallback,
                            uncheckAll: multiSelectCallback,
                            selectedText: self.options.SelectedTextPattern
                        });
                }


                // Switch to desired display mode.

                if (self.options.DisplayType === 'Grid')
                {
                    self._DisplayGrid();
                }
                else
                {
                    self._DisplayList();
                }

                wrapForEnterKey = function (callbackFunc)
                {
                    var wrappedFunction = function (event)
                    {
                        var keycode = parseInt(event.keyCode || event.which, 10);
                        if (keycode === 13)
                        {
                            callbackFunc();
                        }
                    };
                    return wrappedFunction;
                };

                wrapForLink = function (callbackFunc)
                {
                    var wrappedFunction = function (e)
                    {
                        if (e !== undefined && e.preventDefault !== undefined)
                        {
                            e.preventDefault();
                        }
                        callbackFunc();
                    };
                    return wrappedFunction;
                };

                // bind list button.
                displayListCallback = function ( /*e*/) {self._DisplayList(true);};
                jElement
                    .find('.display_list_button')
                    .click(displayListCallback)
                    .keypress(wrapForEnterKey(displayListCallback));


                // bind grid button.
                displayGridCallback = function ( /*e*/) {self._DisplayGrid(true);};
                jElement
                    .find('.display_grid_button')
                    .click(displayGridCallback)
                    .keypress(wrapForEnterKey(displayGridCallback));


                // month drop list changed.
                jElement.on('change', '.multi-calendar-buttons select[name=month]', function ( /*e*/)
                {
                    self.ChangeMonth($(this).find(":selected").val());
                });


                // clicked the previous button.
                jElement.on('click', '.multi-calendar-buttons .previous_button', wrapForLink(function (_event)
                {
                    self.ChangeMonth(null, 'Previous');
                }));

                // clicked the next button.
                jElement.on('click', '.multi-calendar-buttons .next_button', wrapForLink(function (_event)
                {
                    self.ChangeMonth(null, 'Next');
                }));


                // iCal link.
                if (self.options.BindSubscribeButton === true)
                {
                    jElement.on('click', '.display_ical_button', function (e)
                    {
                        e.preventDefault();
                        self._ShowSubscribe();
                    });
                }

                self.Refresh();
            },

            _ShowSubscribe: function ()
            {
                var self = this;
                if (self.options.SubscribeUrl === undefined || self.options.SubscribeUrl === null)
                {
                    return;
                }

                subscribeToCalendars(self.options.SubscribeUrl, self._GetSelectedCalendars());
            },

            ChangeMonth: function (aSelectedMonth, aButtonClicked)
            {
                var self = this;
                var jMonth = $(self.element).find('.multi-calendar-buttons select[name=month]');
                var selectedMonth = aSelectedMonth;
                var buttonClicked = aButtonClicked;
                if (jMonth.length > 0)
                {
                    let currentMonth = jMonth.find(":selected").val();
                    if (aButtonClicked === "Next" || aButtonClicked === "Previous")
                    {
                        if (currentMonth == 'AllFromToday' || currentMonth == 'CurrentMonthFromToday')
                        {
                            let now = new Date(Date.now());
                            currentMonth = (now.getMonth() + 1).toString().padStart(2, '0') + '/01/' + now.getFullYear().toString().padStart(4, '0');
                        }
                        else if (currentMonth == 'AllFromStart')
                        {
                            let options = jMonth.find('option').filter(function (index, element)
                            {
                                let optionValue = $(element).val();
                                return optionValue !== 'AllFromToday' && optionValue !== 'CurrentMonthFromToday' && optionValue !== 'AllFromStart';
                            });

                            if (options.length > 0)
                            {
                                currentMonth = options.val();
                            }
                        }

                        if (aButtonClicked === "Next")
                        {
                            let lNext = jMonth.find('option[value="' + currentMonth + '"]').next();
                            if (lNext.length > 0)
                            {
                                selectedMonth = lNext.val();
                                buttonClicked = null;
                                jMonth.val(selectedMonth);
                            }
                        }
                        else if (aButtonClicked === "Previous")
                        {

                            let current = jMonth.find('option[value="' + currentMonth + '"]');
                            if (current.length !== 0)
                            {
                                let lPrev = current.prev();
                                let previousMonth;
                                if (lPrev.length !== 0 && lPrev.val() !== "" && lPrev.val() !== "AllFromToday" && lPrev.val() !== "CurrentMonthFromToday" && lPrev.val() !== "AllFromStart")
                                {
                                    previousMonth = lPrev.val();
                                }
                                else
                                {
                                    previousMonth = current.val();
                                }

                                selectedMonth = previousMonth;
                                buttonClicked = null;
                                jMonth.val(selectedMonth);
                            }
                        }
                    }
                }
                else
                {
                    console.warn("Did not find the month drop box.");
                }

                var jCalendarElement = $(self.element).find(".fbcms_eventsbody > div");
                if (self.options.DisplayType === 'Grid')
                {
                    if (jCalendarElement.data('ui-GridCalendar'))
                    {
                        jCalendarElement.GridCalendar("ChangeMonth", selectedMonth, buttonClicked, function (aData)
                        {
                            return self._MergeExtraPostData(aData);
                        });
                    }
                }
                else
                {
                    if (jCalendarElement.data('ui-AgendaCalendar'))
                    {
                        jCalendarElement.AgendaCalendar("ChangeMonth", selectedMonth, buttonClicked, function (aData)
                        {
                            return self._MergeExtraPostData(aData);
                        });
                    }
                }
            },

            /// <summary>
            /// Refresh widget to bring everything up-to-date.
            /// </summary>
            Refresh: function ()
            {
                this._SelectMonth();
            },

            /// <summary>
            /// Displays the big calendar grid for the selected month.
            /// </summary>
            _GridOpener: function (aSelectedMonth, aDefaultUrl)
            {
                var self, lSelectedCalendars, lUrl;

                self = this;
                lSelectedCalendars = self._GetSelectedCalendars();
                lUrl = aDefaultUrl + '?m=' + aSelectedMonth + '&c=' + lSelectedCalendars + '&rndm=' + Math.random();

                window.open(lUrl,
                    'Calendar_Grid',
                    "width=760,height=580,location=0,menubar=0,resizable=1,scrollbars=1,status=0,titlebar=1,toolbar=0,screenX=10,left=10,screenY=10,top=10"
                );
            },

            /// <summary>
            /// Returns an object containing post data necessary to request events from the server.
            /// </summary>
            _MergeExtraPostData: function (aOriginalData)
            {
                var self, lSelectedCalendars, lMyData;

                self = this;
                lSelectedCalendars = self._GetSelectedCalendars();
                lMyData = {
                    'Calendars': lSelectedCalendars,
                    'DisplayType': (self.options.DisplayType === 'Grid') ? "Grid" : "List",
                    'HideNavigation': true
                };
                return $.extend({}, aOriginalData, lMyData);
            },

            /// <summary>
            /// Loads updated events data from the ajax server.
            /// </summary>
            _SelectMonth: function (aSelectedDate)
            {
                var self = this;
                var jEventsBody = $(self.element).find(".fbcms_eventsbody");
                var url = (self.options.DisplayType === 'Grid' ? self.options.GridUrl : self.options.AgendaUrl);
                var selectedMonth = aSelectedDate === undefined ? self.GetSelectedMonth() : aSelectedDate;
                var data = {
                    'Month': selectedMonth,
                    'Calendars': self._GetSelectedCalendars(),
                    'DisplayType': (self.options.DisplayType === 'Grid') ? "Grid" : "List",
                    'ShowShell': true,
                    'HideNavigation': true
                };

                function SuccessCallbackFunc(data, _textStatus, request)
                {
                    jEventsBody.html(data);
                    var jCalendarElement = jEventsBody.find("> div");
                    if (self.options.DisplayType === 'Grid')
                    {
                        jEventsBody.removeClass("fbcms_calendar_list_with_nav").addClass("fbcms_calendar_grid");
                        if (jCalendarElement.data('ui-GridCalendar'))
                        {
                            jCalendarElement.GridCalendar("option", "SelectedMonth", selectedMonth);
                            jCalendarElement.GridCalendar("option", "MergeExtraPostData", function (aData)
                            {
                                return self._MergeExtraPostData(aData);
                            });
                        }

                        const startDate = FBUtilities.ParseDateString(request.getResponseHeader("CalViewStartDate")).startOf('month').toFormat('MM/dd/yyyy');
                        $(self.element).find('.multi-calendar-buttons select[name=month]').find(":selected").val(startDate);
                    }
                    else
                    {
                        jEventsBody.removeClass("fbcms_calendar_grid").addClass("fbcms_calendar_list_with_nav");
                        if (jCalendarElement.data('ui-AgendaCalendar'))
                        {
                            jCalendarElement.AgendaCalendar("option", "SelectedMonth", selectedMonth);
                            jCalendarElement.AgendaCalendar("option", "MergeExtraPostData", function (aData)
                            {
                                return self._MergeExtraPostData(aData);
                            });
                        }
                    }
                };

                function FailCallbackFunc()
                {
                    var mySelf, myEventsBody;

                    mySelf = this;
                    myEventsBody = $(mySelf.element).find(".fbcms_eventsbody");
                    myEventsBody.html('<span class="fbError">Error Fetching Calendar</span>');
                };

                $.post(url, data, SuccessCallbackFunc).fail(FailCallbackFunc);
            },

            /// <summary>
            /// Changes to the grid display mode.
            /// </summary>
            _DisplayGrid: function (buttonWasClicked)
            {
                var self = this;
                self._ChangeDisplayType('Grid', buttonWasClicked);
            },

            /// <summary>
            /// Changes to the list display mode.
            /// </summary>
            _DisplayList: function (buttonWasClicked)
            {
                var self = this;
                self._ChangeDisplayType('List', buttonWasClicked);
            },

            /// <summary>
            /// Changes the current display type.
            /// </summary>
            _ChangeDisplayType: function (aDisplayType, _buttonWasClicked) //ignore jslint
            {
                var self, jElement, lSelectedDate, jMonthSelect, jAllOptions, lNext;

                self = this;
                jElement = $(self.element);
                lSelectedDate = self.GetSelectedMonth();
                self.options.DisplayType = (aDisplayType === undefined) ? 'Grid' : aDisplayType;

                jMonthSelect = jElement.find("select[name='month']");
                jAllOptions = jMonthSelect.find("option[value=''],option[value='AllFromStart'],option[value='AllFromToday']");

                if (self.options.DisplayType === 'List')
                {
                    jElement.find('.display_list_button').addClass("selected");
                    jElement.find('.display_grid_button').removeClass("selected");
                    jAllOptions.show();
                }
                else
                {
                    jElement.find('.display_grid_button').addClass("selected");
                    jElement.find('.display_list_button').removeClass("selected");
                    if (jAllOptions.is(':selected'))
                    {
                        var next;
                        for (next = jAllOptions.next(); next.length > 0; next = next.next())
                        {
                            if (!next.is("[value=''],[value='AllFromStart'],[value='AllFromToday']"))
                            {
                                jMonthSelect.val(next.val());
                                break;
                            }
                        }
                    }
                    jAllOptions.hide();
                }

                self._SelectMonth(lSelectedDate);
            },

            /// <summary>
            /// Returns the set of selected calendars as a comma delimited string.
            /// </summary>
            _GetSelectedCalendars: function ()
            {
                var self, calendars;

                self = this;
                calendars = null;
                if (self.options.UsingSelector)
                {
                    calendars = ($(this.element).find("select[name='add_to_calendar_id']").multiselect("getChecked").map(function ()
                    {
                        return this.value;
                    }).get().join(','));
                }
                else
                {
                    calendars = $(this.element).find("input[name='add_to_calendar_id']").val();
                }
                return calendars;
            },

            /// <summary>
            /// Returns the current selected month.
            /// </summary>
            GetSelectedMonth: function ()
            {
                var jMonth = $(this.element).find('.multi-calendar-buttons select[name=month]');
                return jMonth.find(":selected").val();
            }
        });
}(jQuery));

